const colors = {
    extravasation:'#f74f78',
    emergency: '#cc00ff',
    alert: '#ffb15c',
    attention: '#bda501',
    ok: '#16c995',
    high: '#ff7b00',
    low: '#16c995',
    'very-high': '#f74f78',
    moderate: '#fcb900',
    radar:{
        weak:['213,255,255','0,213,255','0,128,170','0,0,179','128,255,85','0,204,127'],
        moderate: ['85,128,0','0,85,0','255,255,0'],
        strong:['255,204,0','255,153,0','213,85,0','255,187,255','255,43,128','128,0,170'],
    }
}

export default colors